export default "__VITE_ASSET__CSyR0vS4__"